<template>
  <div>
    <a-card title="新版微信模板消息配置表">
     <a-button slot="extra" type="primary" @click="addsubtemplate">新增</a-button>
     <!-- 搜索框 -->
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item>
            <a-form-item label="模板ID">
                <a-input  v-model="searchP.templateid"  placeholder="模板ID" ></a-input>
            </a-form-item>
           <a-form-item label="业务类型">
                <a-input  v-model="searchP.businesstype"  placeholder="业务类型" ></a-input>
            </a-form-item>
             <a-form-item label="参数设置">
                <a-input  v-model="searchP.paramskey"  placeholder="参数设置 key1,key2,..." ></a-input>
            </a-form-item>
            <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
          </a-form-item>

          <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
          </a-form-item>

      </a-form>
    </a-card>

    <!-- 微信模板列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
         <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
         <span>
            <router-link
                    :to="{
                    path:'detailsubTemplate',
                    query: {
                        id: record.id,
                        tableType: '2'
                    }
                }"
                >编辑</router-link>
          </span>
          <span>
            <a-popconfirm title="确认删除?" @confirm="() => deleteTemplate(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
     
  </div>
</template>
<script>
import { mapState } from "vuex";
const data = [];

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 100,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },{
        title: "模板ID",
        dataIndex: "templateid",
        width:350
    },
    {
        title: "业务类型",
        dataIndex: "businesstype",
        width:350
    },
    {
        title: "模版参数",
        dataIndex: "paramskey",
        width:450,
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:300
    },
    {
        title: "修改时间",
        dataIndex: "updatetime",
        width:250
    },
    
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            },
        
        };
    },
    methods: {
        handlePageChange(c_p){
            this.getWXtemplatenumList(c_p)
        },

        // 新版微信模板消息列表
        getWXtemplatenumList(cpage){
            let c_params = {
                ...this.searchP
            }
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            c_params.tableType = "2";
            this.tLoading = true;
            this.$store.dispatch({
                type: "wxtemplatemanager/queryWXtemplateList",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "wxtemplatemanager/getEmptySearch",
                showMsg: true
            })
        },

        handleSubmit(e){
            e.preventDefault();
            this.getWXtemplatenumList(1);

        },

        //新增新版模版头
        addsubtemplate(){
            this.$router.push({
                path: "addsubtemplate",
                query: {id:''}
            });
        },

        // 删除新版模版头
        deleteTemplate(key) {
            let c_params = {
                id:key,
                tableType:"2"
            }
            this.$store.dispatch({
                type: "wxtemplatemanager/deleteTemplate",
                params: c_params
            }).then((res) => {
                
                if(res.status == '200'){
                    this.getWXtemplatenumList();
                }
            });
        },

        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },

    },
    computed:{
        ...mapState('wxtemplatemanager', {
            searchP: state => state.searchP,
        })
    },

    mounted(){
        this.getWXtemplatenumList(1);
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
